/* FABRICA-PROPERTY-CHOICE
 *
 * Turns a pill choice into a line item property on the product form.
 *
 * Same mechanism as grind-note.js — a hidden `properties[Name]` input appended
 * to the section's add-to-cart form — with two differences, both learned from
 * that file:
 *
 *   1. Events are delegated from `document` rather than bound on
 *      DOMContentLoaded. A variant change re-renders the product form section,
 *      which throws away anything bound to the old nodes.
 *   2. The hidden input is re-written on submit as well as on change. If a
 *      re-render happened between the click and the click on Add to cart, the
 *      input we appended went with it, and the property would be silently lost
 *      — the customer would have chosen a roast that never reached the order.
 */
(function () {
  var SELECTOR = '[data-property-choice]';

  function formFor(wrapper) {
    var section = wrapper.closest('section') || document;
    return section.querySelector('form[data-type="add-to-cart-form"]');
  }

  function write(wrapper) {
    var form = formFor(wrapper);
    if (!form) return;

    var name = wrapper.getAttribute('data-property-name');
    if (!name) return;
    var field = 'properties[' + name + ']';

    var checked = wrapper.querySelector('input[type="radio"]:checked');
    var input = form.querySelector('input[type="hidden"][name="' + field.replace(/"/g, '\\"') + '"]');

    if (!checked) {
      // Nothing chosen: send no property at all rather than an empty one, so
      // the order carries no half-answer for the roastery to interpret.
      if (input) input.remove();
      return;
    }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = field;
      form.appendChild(input);
    }
    input.value = checked.value;
  }

  function writeAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(write);
  }

  document.addEventListener('change', function (e) {
    var wrapper = e.target.closest && e.target.closest(SELECTOR);
    if (wrapper) write(wrapper);
  });

  // Belt and braces: whatever the form thinks it is sending, make it agree with
  // what is on screen at the moment of submission.
  document.addEventListener(
    'submit',
    function (e) {
      if (!e.target.matches || !e.target.matches('form[data-type="add-to-cart-form"]')) return;
      var section = e.target.closest('section') || document;
      writeAll(section);
    },
    true,
  );

  document.addEventListener('DOMContentLoaded', function () { writeAll(); });
  document.addEventListener('shopify:section:load', function (e) { writeAll(e.target); });
  if (document.readyState !== 'loading') writeAll();
})();
